import script from "./AuthModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthModal.vue?vue&type=script&setup=true&lang=js"

import "./AuthModal.vue?vue&type=style&index=0&id=11201a68&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11201a68"]])

export default __exports__